import { asField } from 'informed';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import themes from '../../theming/themes.js';
import React, { useEffect } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import ToggleSwitchButton from './_ToggleSwitchButton.js';
import ToggleSwitchCheckbox from './_ToggleSwitchCheckbox.js';
import ToggleSwitchContainer from './_ToggleSwitchContainer.js';
import ToggleSwitchLabel from './_ToggleSwitchLabel.js';

var _excluded = ["fieldApi", "fieldState"],
  _excluded2 = ["color", "disabled", "onChange", "onBlur", "initialValue", "forwardedRef", "theme", "label", "field", "toggleSize", "setValueRef", "valueRef"];
var handleChange = function handleChange(setValue, onChange) {
  return function (e) {
    setValue(e.target.checked);
    if (onChange) {
      onChange(e);
    }
  };
};
var handleBlur = function handleBlur(setTouched, onBlur) {
  return function (e) {
    setTouched(true);
    if (onBlur) {
      onBlur(e);
    }
  };
};
var handleKeyDown = function handleKeyDown(value, setValue, disabled) {
  return function (keyEvent) {
    var keycode = keyEvent.which || keyEvent.charCode || keyEvent.keyCode;
    if (keycode === 32 && !disabled) {
      keyEvent.preventDefault();
      setValue(!value);
    }
  };
};
var ToggleSwitch = function ToggleSwitch(_ref) {
  var fieldApi = _ref.fieldApi,
    fieldState = _ref.fieldState,
    props = _objectWithoutProperties(_ref, _excluded);
  var value = fieldState.value;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched;
  var color = props.color,
    disabled = props.disabled,
    onChange = props.onChange,
    onBlur = props.onBlur,
    initialValue = props.initialValue,
    forwardedRef = props.forwardedRef,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? themes["default"] : _props$theme,
    label = props.label,
    field = props.field,
    _props$toggleSize = props.toggleSize,
    toggleSize = _props$toggleSize === void 0 ? 'large' : _props$toggleSize,
    setValueRef = props.setValueRef,
    valueRef = props.valueRef,
    rest = _objectWithoutProperties(props, _excluded2);
  useEffect(function () {
    if (setValueRef) {
      // @ts-ignore strange typescript error around .current being readonly even though MutableRefObject.current is not readonly.
      setValueRef.current = setValue;
    }
  }, []);
  useEffect(function () {
    if (valueRef) {
      valueRef.current = value;
    }
  });
  return /*#__PURE__*/React.createElement(ToggleSwitchContainer, {
    color: color,
    disabled: disabled,
    htmlFor: field,
    on: value,
    onKeyDown: handleKeyDown(value, setValue, disabled),
    tabIndex: 0,
    theme: theme,
    toggleSize: toggleSize
  }, /*#__PURE__*/React.createElement(ToggleSwitchCheckbox, _extends({}, rest, {
    "aria-describedby": "".concat(field, "-label"),
    disabled: disabled,
    id: field,
    onBlur: handleBlur(setTouched, onBlur),
    onChange: handleChange(setValue, onChange),
    tabIndex: -1,
    type: 'checkbox',
    toggleSize: toggleSize,
    value: (value || initialValue || false).toString(),
    checked: value || initialValue || false
  })), /*#__PURE__*/React.createElement(ToggleSwitchButton, {
    color: color,
    on: value,
    theme: theme,
    toggleSize: toggleSize
  }), /*#__PURE__*/React.createElement(ToggleSwitchLabel, {
    id: "".concat(field, "-label"),
    on: value,
    toggleSize: toggleSize
  }), /*#__PURE__*/React.createElement("span", {
    "aria-label": label,
    style: {
      visibility: 'hidden'
    }
  }, label));
};
// @ts-ignore
var _ToggleSwitch = withDefaultTheme(asField(ToggleSwitch));

export default _ToggleSwitch;
